"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("path", {
    d: "M395.8 62.5h-250c-23 0-41.7 18.7-41.7 41.7V125h31.3c5.8 0 10.4 4.7 10.4 10.4 0 5.8-4.7 10.4-10.4 10.4h-31.3V250h31.3c5.8 0 10.4 4.7 10.4 10.4 0 5.8-4.7 10.4-10.4 10.4h-31.3V375h31.3c5.8 0 10.4 4.7 10.4 10.4s-4.7 10.4-10.4 10.4h-31.3c0 23 18.7 41.7 41.7 41.7h250c23 0 41.7-18.7 41.7-41.7V104.2c0-23-18.7-41.7-41.7-41.7zm-125 96.9c23 0 41.7 18.7 41.7 41.7 0 23-18.7 41.7-41.7 41.7-23 0-41.7-18.7-41.7-41.7.1-23.1 18.7-41.7 41.7-41.7zm73.4 189.1H198.3c-5.8.1-10.5-4.6-10.5-10.3 0-.5 0-1 .1-1.6 0-46 37.3-83.3 83.3-83.3s83.3 37.3 83.3 83.3c.8 5.7-3.1 11-8.8 11.8-.7.1-1.5.1-2.2.1h.7z"
  }), (0, _core.jsx)("path", {
    d: "M83.3 83.3H125c11.5 0 20.8 9.3 20.8 20.8s-9.3 20.8-20.8 20.8H83.3c-11.5 0-20.8-9.3-20.8-20.8 0-11.4 9.3-20.8 20.8-20.8zM83.3 333.3H125c11.5 0 20.8 9.3 20.8 20.8s-9.3 20.8-20.8 20.8H83.3c-11.5 0-20.8-9.3-20.8-20.8 0-11.4 9.3-20.8 20.8-20.8zM83.3 208.3H125c11.5 0 20.8 9.3 20.8 20.8s-9.3 20.8-20.8 20.8H83.3c-11.5 0-20.8-9.3-20.8-20.8 0-11.4 9.3-20.8 20.8-20.8z"
  }));
};

exports.default = _default;